import type { ListProps } from './List';
import {
  convertNewListItemPropsToOld,
  convertOldListItemProps,
  type OldListItemProps,
} from '../list-item/converter.old';

export interface OldListProps<T extends string = string>
  extends Omit<ListProps<T>, 'items' | 'onChange' | 'dragOverlayZIndex'> {
  items: Array<OldListItemProps<T>>;
  /** @deprecated dragOverlayZIndex를 대신 사용해주세요. */
  dragOverlayZindex?: ListProps<T>['dragOverlayZIndex'];
  onChange?: (items: Array<OldListItemProps<T>>) => void;
}

export function convertOldListProps<T extends string>(props: OldListProps<T>): ListProps<T> {
  const { items, dragOverlayZindex, onChange, ...restProps } = props;

  return {
    ...restProps,
    items: items.map(convertOldListItemProps),
    dragOverlayZIndex: dragOverlayZindex,
    onChange: onChange ? (nextItems) => onChange(nextItems.map(convertNewListItemPropsToOld)) : undefined,
  };
}
